import { render } from "./Products.vue?vue&type=template&id=0a3f8b54&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=0a3f8b54&lang=scss&scoped=true"
import "./Products.vue?vue&type=style&index=1&id=0a3f8b54&lang=css"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3f8b54"]])

export default __exports__